import { create } from 'zustand';

import { fetchAndActivate, getValue, remoteConfig } from './firebase';

/** Klucz parametru w konsoli Firebase → Remote Config. */
const STRIPE_ENABLE_KEY = 'stripe_enable';

interface FeatureFlags {
  /** Czy panel pokazuje cokolwiek związane ze Stripe (integracja, płatności w punktach). */
  stripeEnable: boolean;
  /** Czy Remote Config zdążył odpowiedzieć. Do diagnostyki — logika ma działać bez tego. */
  resolved: boolean;
}

/**
 * Flagi funkcji z Firebase Remote Config.
 *
 * DLACZEGO STORE, A NIE STAŁA: wartości przychodzą asynchronicznie, już po pierwszym
 * renderze. Stała odczytana przy ładowaniu modułu zamroziłaby wartości domyślne na
 * całą sesję. Store sprawia, że komponenty przerysowują się, gdy odpowiedź dojdzie.
 *
 * FAIL-CLOSED: startujemy z wszystkim wyłączonym i włączamy dopiero po odpowiedzi.
 * Dzięki temu brak sieci, throttling albo wyłączony Remote Config w projekcie dają
 * ten sam, bezpieczny efekt — funkcja pozostaje niewidoczna.
 */
export const useFeatureFlags = create<FeatureFlags>(() => ({
  stripeEnable: false,
  resolved: false,
}));

/** Odczyt poza Reactem (listenery, moduły) — bez subskrypcji. */
export const getFeatureFlags = (): FeatureFlags => useFeatureFlags.getState();

/** Hook do użycia w komponentach — przerysuje je, gdy flaga się zmieni. */
export const useStripeEnable = (): boolean => useFeatureFlags((state) => state.stripeEnable);

/**
 * Pobiera flagi z Remote Config i wpisuje do store'a. Wołane raz, przy starcie aplikacji,
 * BEZ blokowania renderu — aplikacja rusza od razu z wartościami domyślnymi.
 */
export const initFeatureFlags = async (): Promise<void> => {
  try {
    await fetchAndActivate(remoteConfig);
    useFeatureFlags.setState({
      stripeEnable: getValue(remoteConfig, STRIPE_ENABLE_KEY).asBoolean(),
      resolved: true,
    });
  } catch (error) {
    // Brak sieci, FETCH_THROTTLE albo Remote Config nieuruchomiony w projekcie.
    // Zostajemy na wartościach domyślnych — czyli wszystko wyłączone.
    console.warn('[featureFlags] Remote Config niedostępny — zostaję na domyślnych', error);
    useFeatureFlags.setState({ resolved: true });
  }
};
